import { useEffect, useState } from 'react';
import { getQRCode } from '@/util/qr';
import { IGame } from '@/interface/game';
import { DownloadIcon } from './Svg/IconV2';
import { downloadBlobImage } from '@/util/image';

type ARQRProps = {
  gameId: string;
  game: IGame;
  customDomain?: string;
};
const ARQR = ({ gameId, game }: ARQRProps) => {
  const [qrCode, setQRCode] = useState<string>();
  const [gameLink, setGameLink] = useState<string>();
  const [markerThumbnail, setMarkerThumbnail] = useState<string | undefined>(
    undefined
  );
  useEffect(() => {
    if (gameId) {
      const url = window.location.href;
      const qr = getQRCode(url);
      if (game.is_template && game.category === 'MARKERBASED') {
        const elements = game?.config?.elements || [];
        const marker = elements.find(ele => ele.type === 'MARKER');
        if (marker?.thumbnail) setMarkerThumbnail(marker.thumbnail + '?kdbkk');
      }
      setGameLink(url);
      setQRCode(qr);
    }
  }, [gameId]);
  return (
    <div className="h-full w-full bg-[#1A96B4]">
      <div className="flex flex-col justify-center items-center gap-8 h-full">
        <div className="flex justify-between items-center gap-8">
          <div className="flex flex-col gap-4 bg-white rounded-[12px] p-8">
            {qrCode && (
              <img src={qrCode} alt="" className="h-[150px] w-[150px]" />
            )}
            <img
              src="https://rhym.s3.ap-south-1.amazonaws.com/website_assets/static/images/icon/hand_device.svg"
              alt=""
              className="h-[60px] w-auto"
            />
          </div>
          {markerThumbnail && (
            <div className="flex flex-col items-center gap-2 justify-center">
              <div className="bg-gray-300 p-4 w-fit rounded-md relative">
                <img
                  src={markerThumbnail}
                  className="h-[200px] max-w-[250px] w-auto "
                />
                <div
                  className="cursor-pointer absolute right-[-44px] bottom-[-4px] bg-gray-600 rounded-full p-2"
                  onClick={() =>
                    downloadBlobImage(markerThumbnail, 'marker.png')
                  }
                >
                  <DownloadIcon />
                </div>
              </div>
              <div className="">
                <div className="body-2 text-[#b4e5f0]">
                  Then point your device camera at the marker
                </div>
                <div className="text-[14px] text-[#b4e5f0]">
                  For the best AR experience, scan a printed marker.
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="flex flex-col gap-6 mx-auto">
          <div className="">
            <div className="h5-thin text-center text-[#b4e5f0]">
              To access this experience, use your smartphone camera to scan the
              code shown above.
            </div>
            <div className="body-1 text-center text-[#b4e5f0]">
              Or open a browser on your device and enter the url below:
            </div>
          </div>
          <div className="w-full md:w-[80%] mx-auto">
            <div className="bg-white rounded-full p-2 text-center body-2">
              {gameLink}
            </div>
          </div>
          <div className="body-1 text-center text-[#b4e5f0]">
            Android use Chrome - iOS use Safari
          </div>
        </div>
      </div>
    </div>
  );
};

export default ARQR;
